import {
  handleResp,
  getDefaultHeaders,
  extendFetchOptions,
} from "./utils";
import type {
  WrappedCashifyFunction,
  GenericResponse,
} from "./utils";

export interface EncryptionService {
  decrypt: ReturnType<typeof performDecrypt>;
  encrypt: ReturnType<typeof performEncrypt>;
};

type EncodedPlaintext = string;

type EncryptedContent = string;

export const performDecrypt: WrappedCashifyFunction<{ content: EncryptedContent }, GenericResponse<EncodedPlaintext>> = ({ urlPrefix, options }) => {
  return async ({ content }) => {
    let url = `${urlPrefix}/api/v1/encryption/decrypt`;
    let opts = extendFetchOptions(
      {
        method: "POST",
        body: JSON.stringify({ content }),
        headers: {
          ...getDefaultHeaders(),
          "Content-Type": "application/json",
        },
      },
      options,
    );
    return fetch(url, opts).then((resp) => handleResp(resp));
  };
};
export const performEncrypt: WrappedCashifyFunction<{ encodedPlaintext: EncodedPlaintext }, GenericResponse<EncryptedContent>> = ({ urlPrefix, options }) => {
  return async ({ encodedPlaintext }) => {
    let url = `${urlPrefix}/api/v1/encryption/encrypt`;
    let opts = extendFetchOptions(
      {
        method: "POST",
        body: JSON.stringify({ encodedPlaintext }),
        headers: {
          ...getDefaultHeaders(),
          "Content-Type": "application/json",
        },
      },
      options,
    );
    return fetch(url, opts).then((resp) => handleResp(resp));
  };
};
